import { api } from '../../api/client';
import { API_BASE_URL } from '../../config/api';

function authOptions(token) {
  return { headers: { Authorization: `Bearer ${token}` } };
}

export function startIdentityChange(token, changeType, stillHasMobile) {
  return api.post(
    `${API_BASE_URL}/auth/identity-change/start`,
    { change_type: changeType, still_has_mobile: Boolean(stillHasMobile) },
    authOptions(token),
  );
}

export function confirmCurrentIdentity(token, requestToken, otp) {
  return api.post(
    `${API_BASE_URL}/auth/identity-change/confirm-current`,
    { token: requestToken, otp },
    authOptions(token),
  );
}

export function proposeIdentityChange(token, requestToken, newValue) {
  return api.post(
    `${API_BASE_URL}/auth/identity-change/propose`,
    { token: requestToken, new_value: newValue },
    authOptions(token),
  );
}

export function confirmNewIdentity(token, requestToken, otp) {
  return api.post(
    `${API_BASE_URL}/auth/identity-change/confirm-new`,
    { token: requestToken, otp },
    authOptions(token),
  );
}

export function getIdentityChangeStatus(token, requestToken) {
  return api.get(
    `${API_BASE_URL}/auth/identity-change/${encodeURIComponent(requestToken)}/status`,
    authOptions(token),
  );
}
